






























import { Component, Prop, Model } from 'vue-property-decorator';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class UiSwitcher extends PlanLimitsMixin {
  @Model('change')
  modelValue: any

  @Prop({ default: '' })
  labelHelp: string

  @Prop({ default: false })
  disabled: boolean

  @Prop({ default: false })
  textBold: boolean

  @Prop({ default: true })
  labelBeforeSwitcher: boolean

  @Prop({ default: '' })
  label: string;

  @Prop({ default: true })
  trueValue: any

  @Prop({ default: false })
  falseValue: any

  get isChecked() {
    if (this.trueValue === this.modelValue) {
      return true
    } else if (this.falseValue === this.modelValue) {
      return false
    }
  }

  get switcherValue() {
    if (this.modelValue === this.falseValue) {
      return this.trueValue
    } else if (this.modelValue === this.trueValue) {
      return this.falseValue
    }

    return !this.modelValue
  }

  onSwitch() {
    if(this.showPlanLimitsIcon){return this.handleClickPlanLimits()}
    if (!this.disabled) {
      this.$emit('change', this.switcherValue);
    }
  }
}
